import { Typography } from 'antd';
import { LegalPage } from './LegalPage';

const { Title, Paragraph } = Typography;

export function TermsPage() {
  return (
    <LegalPage title="Terms of Service" updated="July 15, 2026">
      <Paragraph>
        These Terms of Service (&quot;Terms&quot;) govern your access to and use of the Content
        Agents platform and related services (the &quot;Service&quot;). By creating an account or
        using the Service, you agree to these Terms.
      </Paragraph>

      <Title level={4}>1. The Service</Title>
      <Paragraph>
        Content Agents helps businesses plan, generate, schedule and publish marketing content and
        videos, and connect their own third-party accounts (such as YouTube, TikTok, Facebook and
        Instagram) so content can be published on their behalf. You are responsible for the content
        you create and publish through the Service.
      </Paragraph>

      <Title level={4}>2. Accounts</Title>
      <Paragraph>
        You must provide accurate information and keep your credentials secure. You are responsible
        for all activity under your account. You must be authorized to manage any third-party
        account you connect to the Service.
      </Paragraph>

      <Title level={4}>3. Connected platforms</Title>
      <Paragraph>
        When you connect a third-party account, you authorize the Service to access and act on that
        account only as needed to provide the features you enable (for example, uploading and
        publishing videos, or updating channel branding). Your use of each platform remains subject
        to that platform&apos;s own terms and policies. You may disconnect a platform at any time
        from the Integrations settings, which revokes the Service&apos;s access.
      </Paragraph>

      <Title level={4}>4. Acceptable use</Title>
      <Paragraph>
        You agree not to use the Service to create or distribute unlawful, infringing, deceptive or
        harmful content, to violate any platform&apos;s policies, or to attempt to disrupt or gain
        unauthorized access to the Service.
      </Paragraph>

      <Title level={4}>5. Intellectual property</Title>
      <Paragraph>
        You retain ownership of the content you provide and generate. You grant us the limited
        rights needed to operate the Service (such as storing and transmitting your content to the
        platforms you choose to publish to).
      </Paragraph>

      <Title level={4}>6. Disclaimers &amp; liability</Title>
      <Paragraph>
        The Service is provided &quot;as is&quot; without warranties of any kind. To the maximum
        extent permitted by law, we are not liable for indirect or consequential damages arising
        from your use of the Service.
      </Paragraph>

      <Title level={4}>7. Termination</Title>
      <Paragraph>
        You may stop using the Service at any time. We may suspend or terminate access for breach of
        these Terms. Upon termination, your right to use the Service ends.
      </Paragraph>

      <Title level={4}>8. Changes</Title>
      <Paragraph>
        We may update these Terms from time to time. Continued use of the Service after changes take
        effect constitutes acceptance of the updated Terms.
      </Paragraph>

      <Title level={4}>9. Contact</Title>
      <Paragraph>
        Questions about these Terms? Contact us at{' '}
        <a href="mailto:support@clairglow.com">support@clairglow.com</a>.
      </Paragraph>
    </LegalPage>
  );
}
